import Route from '@ember/routing/route'
import { service } from '@ember/service'
import RSVP from 'rsvp'
import type { StudentScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type MathsStudentSummaryRoute from 'teacher-ui-client/reporting/ui-scope/maths/student-summary/route'
import type { NormalizedInterval } from 'date-fns'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export default class extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>
    const { student } = this.modelFor('reporting.ui-scope.maths.student-summary') as ModelFor<MathsStudentSummaryRoute>

    const statsScope: StudentScope = { scope: 'student', ids: [student.id] }

    const product: LegacyProductMs = 'maths'
    const stats = await this.makeStatsRequests(product, statsScope, period)

    return {
      student,
      students: scopedData.students,
      period,
      ...stats,
    }
  }

  makeStatsRequests(product: LegacyProductMs, scope: StudentScope, period: NormalizedInterval) {
    return RSVP.hash({
      summary: this.studentEvents.summaryStudentsMs(product, scope, period),
    })
  }
}
